export const themes = {
  package: {
    root: 'overflow-hidden',
    unit: 'block font-sans font-bold text-center text-sm uppercase',
    viewRates: 'flex font-bold font-sans justify-center leading-tight text-center text-md',
    viewRatesLabel: 'rtl:ml-2',
  },
  thumbnail: {
    priceRoot: 'font-brand flex items-center',
    root: 'flex items-center leading-half overflow-hidden pt-1 pb-2',
    unit: 'inline-block font-sans text-base text-gray-darker',
    initialPrice: 'text-grenadine -order-1 -mb-1',
    viewRates: 'flex items-center underline font-sans leading-one text-base',
    viewRatesIcon: 'hidden',
    viewRatesLabel: 'rtl:ml-1',
  },
  instagram: {
    priceRoot: 'font-brand text-inherit',
    root: 'w-full flex items-center leading-half truncate text-white',
    unit: 'inline-block font-sans text-sm sm:text-base',
    initialPrice: 'text-grenadine',
    viewRates: 'flex items-center underline font-sans leading-one text-sm sm:text-base',
    viewRatesIcon: 'hidden',
    viewRatesLabel: 'rtl:ml-1',
  },
  ticket: {
    root: 'overflow-hidden',
    unit: 'font-bold font-sans inline-block text-sm',
    viewRates: 'flex items-center font-bold font-sans leading-one text-xl',
    viewRatesLabel: 'rtl:ml-2',
  },
  remote: {
    root: 'overflow-hidden text-blue flex',
    unit: 'font-bold font-sans inline-block text-sm',
    viewRates: 'flex items-center font-bold font-sans leading-one text-xl',
    viewRatesLabel: 'rtl:ml-2',
    initialPrice: '-order-1',
    priceRoot: 'flex items-center',
  },
  joyviewRemote: {
    root: 'overflow-hidden text-waterGreen flex',
    unit: 'font-bold font-sans inline-block text-sm',
    viewRates: 'flex items-center font-bold font-sans leading-one text-xl',
    viewRatesLabel: 'rtl:ml-2',
    initialPrice: '-order-1',
    priceRoot: 'flex items-center',
  },
  compare: {
    priceRoot: 'font-brand flex items-center w-full',
    root: 'flex items-center leading-half overflow-hidden pt-1',
    unit: 'inline-block font-sans text-sm md:text-base text-gray-darker truncate leading-one',
    initialPrice: 'text-grenadine -order-1 -mb-1',
    viewRates: 'flex items-center underline font-sans leading-one text-sm md:text-base',
    viewRatesIcon: 'hidden',
    viewRatesLabel: 'rtl:ml-1',
  },
};
